import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const ExportDbButton = () => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/export/mongo.json", { responseType: "blob" });
      const name = (r.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "hypexlabs-mongo.json";
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Database exported — ${name}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Export failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      onClick={run}
      disabled={busy}
      className="inline-flex items-center gap-2 px-3 py-1.5 border border-zinc-800 hover:border-[#00E5FF]/60 text-[10px] uppercase tracking-[0.2em] font-mono text-zinc-300 hover:text-[#00E5FF] transition-colors disabled:opacity-50"
      data-testid="admin-export-db-btn"
      title="Download every collection as JSON (secrets redacted)"
    >
      {busy ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />}
      export database
    </button>
  );
};
